import { render, staticRenderFns } from "./propage.vue?vue&type=template&id=a6a72264&scoped=true&"
import script from "./propage.vue?vue&type=script&lang=js&"
export * from "./propage.vue?vue&type=script&lang=js&"
import style0 from "./propage.vue?vue&type=style&index=0&id=a6a72264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a72264",
  null
  
)

export default component.exports